import { z } from 'my-zod'
import { productLineOptions } from '../../internal'
import { vehiclesModel } from '../vehicle'

export const maintenanceProgramModel = z.object({
  id: z.string(),
  shortId: z.string(),
  name: z.string().min(1, 'Required'),
  description: z.string().min(1, 'Required'),
  outfitterId: z.number(),
  productLines: z.enum(productLineOptions).array(),
  modelFamilyIds: z.number().array(),
  associationType: z.enum(['specificVins', 'productLines', 'modelFamilyIds']),
  vehicleIds: vehiclesModel.shape.id.array(),
  schedules: z
    .object({
      id: z.string(),
      maintenanceProgramId: z.string(),
      type: z.enum(['Recurring', 'OneTime']),
      mileage: z.number().nullable(),
      engineHours: z.number().nullable(),
      durationDays: z.number().nullable(),
      earlySubmissionMileage: z.number().nullable(),
      earlySubmissionEngineHours: z.number().nullable(),
      serviceTaskIds: z.number().array(),
      name: z.string()
    })
    .array()
    .min(1, 'Required')
})

export type maintenanceProgramModel = z.infer<typeof maintenanceProgramModel>

export const superRefineAssociationType = (
  values: Pick<maintenanceProgramModel, 'associationType' | 'vehicleIds' | 'productLines' | 'modelFamilyIds'>,
  ctx: z.RefinementCtx
) => {
  if (values.associationType === 'specificVins' && values.vehicleIds.length === 0) {
    ctx.addIssue({
      message: 'Please select at least one vehicle',
      code: 'custom',
      path: ['vehicleIds']
    })
  }

  if (values.associationType === 'productLines' && values.productLines.length === 0) {
    ctx.addIssue({
      message: 'Please select at least one product line',
      code: 'custom',
      path: ['productLines']
    })
  }

  if (values.associationType === 'modelFamilyIds' && values.modelFamilyIds.length === 0) {
    ctx.addIssue({
      message: 'Please select at least one model family',
      code: 'custom',
      path: ['modelFamilyIds']
    })
  }
}
